"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadController = void 0;
var UploadController = /** @class */ (function () {
    function UploadController(config, logger) {
        var _this = this;
        this.logger = logger;
        this.onUploadIntermediate = function (speed_bps) { };
        this.onUploadComplete = function (data) { };
        this.onError = function (err) { };
        this.uploadConfig = {
            uploadMaxBytes: 15000000,
            uploadDuration: 12,
            uploadInterval: 0.75,
            uploadServer: "https://speedtest-21.vodafone.anw.net/empty.txt"
        };
        this.uploadResult = {
            intermediateValues: [],
            transferredBytes: 0,
            transferDuration: 0
        };
        this.stopHandler = undefined;
        this.sectionHandler = undefined;
        this.xhr = new XMLHttpRequest();
        this.debugLevel = 0;
        this.isRunning = false;
        this.data = "";
        // taken from the old code:
        this.bytesUploadedLastSection = 0;
        this.bytesUploadedPush = 0;
        this.bytesUploadedTotal = 0;
        this.getSectionSpeedUploadCounter = 0;
        this.uploadStartTime = null;
        this.uploadSectionStartTime = null;
        this.uploadSectionCurrentTime = null;
        this.getSectionSpeed = function () {
            _this.debug("getSectionSpeed");
            var currentTime = _this.uploadSectionCurrentTime;
            var newBytes = (_this.bytesUploadedTotal + _this.bytesUploadedPush) - _this.bytesUploadedLastSection;
            var newTime = currentTime.getTime() - _this.uploadSectionStartTime.getTime();
            if (newBytes > 0 && newTime > 0) {
                _this.bytesUploadedLastSection = _this.bytesUploadedTotal + _this.bytesUploadedPush;
                _this.uploadSectionStartTime = _this.uploadSectionCurrentTime;
                var newSpeed = Math.round(8 * newBytes / newTime);
                var overallTime = currentTime.getTime() - _this.uploadStartTime.getTime();
                _this.uploadResult.transferDuration = overallTime;
                _this.uploadResult.transferredBytes = _this.bytesUploadedTotal + _this.bytesUploadedPush;
                if ((_this.getSectionSpeedUploadCounter > 1) || (newSpeed < 60000)) {
                    _this.uploadResult.intermediateValues.push(newSpeed);
                    _this.onUploadIntermediate(newSpeed);
                }
                // intermediate callback
                _this.debug("newSpeed = " + newSpeed);
                _this.getSectionSpeedUploadCounter++;
            }
        };
        this.onUploadError = function (ev) {
            _this.onError(ev);
        };
        this.stop = function () {
            _this.debug("stop");
            clearTimeout(_this.stopHandler);
            clearInterval(_this.sectionHandler);
            _this.stopHandler = undefined;
            // abort a running xhr
            _this.xhr.abort();
            // reset data.
            _this.isRunning = false;
            // free data. (garbage collector will do this eventually)
            _this.data = "0";
            // remove handlers
            clearTimeout(_this.sectionHandler);
            clearTimeout(_this.stopHandler);
            // close the connection, if it is open
            if (_this.xhr && _this.xhr.readyState === XMLHttpRequest.OPENED) {
                _this.xhr.abort();
            }
        };
        this.finish = function () {
            _this.stop();
            _this.onUploadComplete(_this.uploadResult);
        };
        // Push data to server.
        this.pushData = function () {
            var self = _this;
            _this.debug("pushData");
            // Open XHR request to send data. (Todo: check if ipv6 is possible)
            _this.xhr.open('POST', _this.uploadConfig.uploadServer, true);
            _this.xhr.onerror = self.onUploadError;
            _this.xhr.onabort = function () { return self.getSectionSpeed(); };
            _this.xhr.upload.onprogress = function (evt) {
                self.bytesUploadedPush = evt.loaded;
                self.uploadSectionCurrentTime = new Date();
            };
            _this.xhr.onload = function () {
                self.bytesUploadedTotal += self.bytesUploadedPush;
                self.bytesUploadedPush = 0;
                self.pushData();
            };
            _this.xhr.send(_this.data);
        };
        // Start the upload test.
        this.start = function () {
            var self = _this;
            _this.debug("start");
            if (_this.isRunning) {
                return false;
            }
            _this.isRunning = true;
            // Get section speed every "uploadInterval" seconds.
            _this.sectionHandler = window.setInterval(self.getSectionSpeed, _this.uploadConfig.uploadInterval * 1000);
            // Clear stop handler.
            clearTimeout(_this.stopHandler);
            _this.stopHandler = undefined;
            // Stop upload test after "uploadDuration" seconds.
            _this.stopHandler = window.setTimeout(self.finish, _this.uploadConfig.uploadDuration * 1000);
            _this.uploadStartTime = new Date();
            _this.uploadSectionStartTime = _this.uploadStartTime;
            _this.uploadSectionCurrentTime = _this.uploadStartTime;
            _this.pushData();
        };
        // -------------------------------------------------------------------------
        this.debug = function () {
            var arg = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                arg[_i] = arguments[_i];
            }
            if (_this.debugLevel > 0)
                _this.logger.debug(arg);
        };
        // .data will contain 15 MB of data.
        this.uploadConfig = config;
        for (var i = 0; i < 15e6 - 1; i++) {
            this.data += '0';
        }
    }
    return UploadController;
}());
exports.UploadController = UploadController;
//# sourceMappingURL=UploadController.js.map